module.exports = __webpack_public_path__ + "static/turtle-creek-house06-6ad22da3d994d18ab281bc32409eb66b.jpg";